import { connect } from 'react-redux'
import { getChildNodesById } from '../../core/selectors'
import LayoutMagnifier from '../components/layoutMagnifier'

const getElements = (state, id, index) => {
  const layouts = getChildNodesById({
    state,
    id,
  })

  if (layouts && Array.isArray(layouts)) {
    return layouts.map((layout) => {
      if (('elements' in layout) && (layout.elements[index])) {
        return {
          image: layout.elements[index].images[0],
          title: `${layout.elements[index].title}: ${layout.title}`,
        }
      }
      return null
    })
  }
  return null
}

const mapStateToProps = (state, ownProps) => ({
  elements: getElements(state, ownProps.node, ownProps.index),
})

export default connect(
  mapStateToProps,
  null,
)(LayoutMagnifier)



// WEBPACK FOOTER //
// ./src/modules/houseType/containers/layoutMagnifier.js